import React from 'react';

const Media = () => {
    return (
        <section id="media" className="media-section">
            <div className="lg-glass lg-glass--section">
                <span className="section-heading__accent text-center d-block">Extra</span>
                <h2 className="section-heading">Media</h2>
                <p className="text-center text-white-50 mb-4 px-md-4">
                    Un clásico de internet — dale play si te atreves 😉
                </p>
                <div className="lg-media-frame ratio ratio-16x9 mx-auto" style={{ maxWidth: '920px' }}>
                    <iframe
                        src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                        title="Rick Astley - Never Gonna Give You Up"
                        
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            </div>
        </section>
    );
};
{/*
⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣇⢻⣿⢸⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠟⠀⣠⣶⣶⡟⢡⣾⣿⣿⣿
⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡘⠟⢨⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡏⠀⣴⡟⣿⣿⠇⣾⣿⣿⣿⣿
⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠁⢰⣾⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⡄⢿⣿⢸⡟⠄⣿⣿⣿⣿⣿
⣿⣿⣿⣿⣿⣿⣿⣿⡿⠟⢁⣶⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣄⢻⣷⣧⠀⠉⠉⠉⠩⢿
⣿⣿⣿⣿⡿⢛⠍⠀⠀⢠⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡎⣿⡏⠀⠀⢀⣴⣶⣦
⣿⣿⣿⠋⠐⠰⠂⠀⢠⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⢹⠃⡀⡄⣿⣿⣿⡿
⠙⠛⠁⠀⠀⠀⠀⠀⣾⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠾⠀⢵⣿⣿⣿⠟⣡
⣷⣀⠀⠀⠀⠀⠀⠀⣿⠏⠌⣛⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⢿⡷⠈⢰⡸⣿⣿⣿⣿⠀⢸⣾⣿⠟⣠⣾⣿
⣿⣿⣦⠀⠀⠀⠀⠀⣿⠀⠀⢈⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣻⣻⣿⣿⣿⣿⣿⠈⠃⠀⠀⢠⣿⣿⣿⡏⠀⠈⠉⣵⢺⣿⣿⣿
⢿⣿⡿⣷⡄⠀⠀⠀⠹⣷⣤⣤⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⢿⣿⣿⣿⣿⣿⣿⣷⣶⣶⣶⣿⣿⣿⣿⠁⠀⠀⣼⢃⣾⠏⣹⣿
⣆⠻⣿⡘⣿⡄⠀⠀⠀⠈⢿⣿⣿⣿⠿⢿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡌⢾⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡿⢃⠀⠀⣼⢏⣾⡿⢰⣿⡿
⣿⡄⢻⣧⠹⣿⡄⠀⠀⠀⠐⠙⠿⣿⣿⣿⣿⣿⠟⢋⣿⣿⣿⣿⣿⣿⣷⡀⠫⣿⣿⣿⣿⣿⣿⣿⣿⣿⠋⣠⠇⠀⠀⡟⣼⡿⠁⣾⣿⡷
⢸⣿⡀⣿⡆⢹⣧⠀⠀⠀⠀⠀⠀⠀⠀⢉⣉⣤⣶⣿⣿⣿⣿⣿⣿⣿⣿⣿⣦⣈⠉⠋⠉⠛⠛⠛⢉⣤⣾⡿⠀⠀⠀⠡⢹⡄⠀⣿⣿⣰
⠈⣿⡗⣼⡟⠘⣿⡇⠀⠀⠀⠀⠀⢸⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣶⣶⣶⣶⣿⣿⡟⣿⠇⠀⠀⠀⠘⠀⣥⣄⣿⡇⣿
⢰⣿⢇⣿⢁⣷⡘⠷⠀⠀⠀⠀⠀⠈⠻⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠟⠀⠀⠀⠀⠀⠀⠈⠽⠿⢸⣿
⡎⢿⡾⢏⣾⣿⣿⡤⢤⠀⠀⠀⠀⠀⠉⠻⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⣇⠀⠀⠀⠀⠀⢀⣶⣶⡶⣾⣿
*/};

export default Media;
